'use strict';

/* =========================================================================
   BASIS — Header & overlay menu JS
   Ports basis-redesign/assets/js/script.js → initClock() + initMenu()
   ========================================================================= */

const BASIS_FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');


/* --- Overlay menu : open / close + focus trap + ESC ---------------------- */
function initBasisMenu() {
  const menu = document.getElementById('main-menu');
  const toggle = document.getElementById('menu-toggle');
  const closeBtn = document.getElementById('menu-close');
  if (!menu || !toggle || !closeBtn) return;

  let lastFocused = null;

  const isOpen = () => menu.classList.contains('open');

  function open() {
    lastFocused = document.activeElement;
    menu.classList.add('open');
    menu.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => closeBtn.focus());
  }

  function shut() {
    menu.classList.remove('open');
    menu.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function' && document.contains(lastFocused)) {
      lastFocused.focus();
    } else {
      toggle.focus();
    }
  }

  toggle.addEventListener('click', open);
  closeBtn.addEventListener('click', shut);

  document.addEventListener('keydown', (e) => {
    if (!isOpen()) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      shut();
      return;
    }

    if (e.key === 'Tab') {
      const focusable = Array.from(menu.querySelectorAll(BASIS_FOCUSABLE_SELECTOR));
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
}


/* --- Horloge Paris : HH:MM:SS + (GMT±X), MAJ chaque seconde -------------- */
function initBasisClock() {
  const clockTime = document.querySelector('.header__clock-time');
  const clockTz = document.querySelector('.header__clock-tz');
  if (!clockTime) return;

  const timeFormatter = new Intl.DateTimeFormat('fr-FR', {
    timeZone: 'Europe/Paris',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  const tzFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Paris',
    timeZoneName: 'shortOffset',
  });

  function getTzLabel(now) {
    const part = tzFormatter.formatToParts(now).find((p) => p.type === 'timeZoneName');
    return part ? part.value : 'GMT';
  }

  function updateClock() {
    const now = new Date();
    clockTime.textContent = timeFormatter.format(now);
    clockTime.setAttribute('datetime', now.toISOString());
    if (clockTz) clockTz.textContent = `(${getTzLabel(now)})`;
  }

  updateClock();
  setInterval(updateClock, 1000);
}


/* --- Bootstrap ----------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  initBasisClock();
  initBasisMenu();
});
